import React, { FC } from 'react';

export const IconCheck: FC = props => (
  <svg data-dir="ltr" viewBox="0 0 20 15.5" aria-hidden {...props}>
    <title>Check Icon</title>
    <path d="M7.83 14.7A2.57 2.57 0 0 1 6 14L.87 8.81a2.57 2.57 0 0 1 3.64-3.63L7.83 8.5l7.6-7.6a2.57 2.57 0 0 1 3.64 3.63L9.65 14a2.58 2.58 0 0 1-1.82.7z" />
  </svg>
);
